// This is a Universal JavaScript Module that can be used by both Node.js and React.

const UNIFIED_GAMES_CONFIG_DATA = [
  {
    // Core Identity
    id: 'bible-books',
    title: 'Books of the Bible',
    description: 'Test your knowledge of biblical books',
    
    // Routing & Keys
    route: '/solve/bible-books',
    streakKey: 'bibleBooksStreak',
    dailyKey: 'dailyBibleBooks',
    sessionStorageKey: 'bibleBooksDirectoryFiltersV1',
    
    // API & Data Mapping
    apiEndpoint: '/api/cards/bible-books',
    dailyApiEndpoint: '/api/daily/bible-books',
    dailyDataField: 'book',
    itemsArrayField: 'allBooks',

    // UI Text
    itemName: 'book',
    itemNamePlural: 'books',
    itemNameCapitalized: 'Books',
    placeholderText: 'Type book name...',
    directoryButtonText: 'View Books',

    // CSS
    cssPrefix: 'bible-books-game',

    // Visual Design
    category: 'Religious Knowledge',
    shortTitle: 'Books of the Bible',
    icon: 'FaCross',
    colors: {
      primary: '#F5E6D3',
      secondary: '#FFF8E7',
      text: '#8B4513'
    }
  },
  {
    // Core Identity
    id: 'slay-the-spire',
    title: 'Slay the Spire',
    description: 'Guess cards from the deck-building roguelike',
    
    // Routing & Keys
    route: '/solve/slay-the-spire',
    streakKey: 'stsStreak',
    dailyKey: 'dailySlayTheSpire',
    sessionStorageKey: 'stsCardDirectoryFiltersV2',
    
    // API & Data Mapping
    apiEndpoint: '/api/cards/slay-the-spire',
    dailyApiEndpoint: '/api/daily/slay-the-spire',
    dailyDataField: 'card',
    itemsArrayField: 'allCards',

    // UI Text
    itemName: 'card',
    itemNamePlural: 'cards',
    itemNameCapitalized: 'Cards',
    placeholderText: 'Type card name...',
    directoryButtonText: 'View Card Directory',

    // CSS
    cssPrefix: 'slay-the-spire-game',

    // Visual Design
    category: 'Deck-Building Cards',
    shortTitle: 'Slay the Spire',
    icon: 'GiCardRandom',
    colors: {
      primary: '#8B0000',
      secondary: '#CD5C5C',
      text: '#FFFFFF'
    }
  },
  {
    // Core Identity
    id: 'subnautica-creatures',
    title: 'Subnautica Creatures',
    description: 'Explore and identify creatures from the ocean depths of Subnautica',
    
    // Routing & Keys
    route: '/solve/subnautica-creatures',
    streakKey: 'subnauticaCreaturesStreak',
    dailyKey: 'dailySubnauticaCreatures',
    sessionStorageKey: 'subnauticaCreaturesDirectoryFiltersV1',
    
    // API & Data Mapping
    apiEndpoint: '/api/cards/subnautica-creatures',
    dailyApiEndpoint: '/api/daily/subnautica-creatures',
    dailyDataField: 'creature',
    itemsArrayField: 'allCreatures',

    // UI Text
    itemName: 'creature',
    itemNamePlural: 'creatures',
    itemNameCapitalized: 'Creatures',
    placeholderText: 'Type creature name...',
    directoryButtonText: 'View Creatures',

    // CSS
    cssPrefix: 'subnautica-creatures-game',

    // Visual Design
    category: 'Ocean Creatures',
    shortTitle: 'Subnautica Creatures',
    icon: 'GiAnglerFish',
    colors: {
      primary: '#006994',
      secondary: '#40E0D0',
      text: '#FFFFFF'
    }
  },
  {
    // Core Identity
    id: 'aoe2-units',
    title: 'Age of Empires II',
    description: 'Guess units from the classic RTS game',
    
    // Routing & Keys
    route: '/solve/aoe2-units',
    streakKey: 'aoe2UnitsStreak',
    dailyKey: 'dailyAoe2Units',
    sessionStorageKey: 'aoe2UnitsDirectoryFiltersV1',
    
    // API & Data Mapping
    apiEndpoint: '/api/cards/aoe2-units',
    dailyApiEndpoint: '/api/daily/aoe2-units',
    dailyDataField: 'unit',
    itemsArrayField: 'allUnits',

    // UI Text
    itemName: 'unit',
    itemNamePlural: 'units',
    itemNameCapitalized: 'Units',
    placeholderText: 'Type unit name...',
    directoryButtonText: 'View Units',

    // CSS
    cssPrefix: 'aoe2-units-game',

    // Visual Design
    category: 'RTS Units',
    shortTitle: 'Age of Empires II',
    icon: 'GiSwordWound',
    colors: {
      primary: '#8B4513',
      secondary: '#A0522D',
      text: '#FFFFFF'
    }
  },
  {
    // Core Identity
    id: 'pokemon',
    title: 'Pokemon',
    description: 'Guess Pokemon from the original 151',
    
    // Routing & Keys
    route: '/solve/pokemon',
    streakKey: 'pokemonStreak',
    dailyKey: 'dailyPokemon',
    sessionStorageKey: 'pokemonDirectoryFiltersV1',
    
    // API & Data Mapping
    apiEndpoint: '/api/cards/pokemon',
    dailyApiEndpoint: '/api/daily/pokemon',
    dailyDataField: 'pokemon',
    itemsArrayField: 'allPokemon',

    // UI Text
    itemName: 'pokemon',
    itemNamePlural: 'pokemon',
    itemNameCapitalized: 'Pokemon',
    itemNameSingular: 'Pokemon',
    placeholderText: 'Type pokemon name...',
    directoryButtonText: 'Pokemon Directory',

    // CSS
    cssPrefix: 'pokemon-game',

    // Visual Design
    category: 'Pokemon',
    shortTitle: 'Pokemon',
    icon: 'Pokeball',
    colors: {
      primary: '#FFCB05',
      secondary: '#CC0000',
      text: '#FFFFFF'
    }
  }
];

// Export for server-side (CommonJS) and tooling that default-imports CJS
module.exports = { UNIFIED_GAMES_CONFIG_DATA };
